// This is used
import type { ContestManageStore } from '../types/store';

import { flattenArray } from './flattenArray';
import { getFieldQueryByField } from './getFieldQueryByField';
import { getSectionQuery } from './getSectionQuery';

const resolveField = (cache: ContestManageStore, fieldKey: string): string | string[] => {
  const field = cache.fields[fieldKey];
  const fieldQuery = getFieldQueryByField(cache, field);
  switch (fieldQuery.type) {
    case 'DynamicFields': {
      if (!fieldQuery.data) {
        return field.key;
      }

      return flattenArray(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        fieldQuery.data?.map((fieldKey) => resolveField(cache, fieldKey))
      );
    }
    default: {
      return field.key;
    }
  }
};

export const getFlattenFields = (cache: ContestManageStore, sectionKey: string) => {
  const section = getSectionQuery(cache, sectionKey);
  if (!section?.data) {
    return [];
  }
  if (section.type === 'DynamicSections') {
    return [];
  }

  // Returning SkippedSection type when we flatten fields
  // We checked for Skippped Section and do early return
  if (section.type === 'SkippedSection') {
    return section.type;
  }

  return flattenArray(section.data.fields.map((fieldKey) => resolveField(cache, fieldKey)));
};
